import axios from 'api/axios'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 * @module DocumentacionLaboral
 */

/**
 * Fetch the calendar data for the user
 * @param {string} [document_type]
 * @param {number} [iteration]
 * @returns {import('common/types/connections_types').UseFetchHookResponse<docLaboralMetaDTO>}
 */
const useFetchLaboralMeta = (document_type = null, iteration = 0, user = null) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }

    setLoading(true)
    setError(null)
    axios
      .get(`/doclaboral/meta?tipo=${document_type ?? ''}&user=${user ?? ''}`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [document_type, iteration, user])

  return { response, error, loading }
}

export default useFetchLaboralMeta
